export default __webpack_public_path__ + "static/media/kitchen5-beforeD-1024w.ba470289.avif";